import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textBold',
  standalone: false,
})
export class TextBoldPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return value.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
  }
}
